export function getSettings(state) {
  return state?.settings || {};
}

export function getSetting(state, name) {
  return state?.settings[name] || '';
}

export function getUpdating(state) {
  return state?.updating || false;
}

export function getLoading(state) {
  return state?.loading || false;
}

export function getError(state) {
  return state?.error || '';
}

export function getTestResults(state) {
  return state?.testResults || {};
}

export function getTestResult(state, builder) {
  return state?.testResults?.[builder] || null;
}

export function getBuilderConfigs(state) {
  // Default builder configurations
  const defaultConfigs = {
    elementor: {
      name: "Elementor",
      description: "Popular drag & drop page builder",
      elements: {
        text_marquee: true,
        image_marquee: true,
        animated_heading: true,
        animated_word_roller: true,
        news_ticker: true,
        post_marquee: true,

      },
      coming_soon: {
        video_marquee: true,
        button_marquee: true,
        card_marquee: true,
        media_marquee: true,
        product_marquee: true,
      },
    },
    gutenberg: {
      name: "Gutenberg",
      description: "WordPress native block editor",
      elements: {
        infinite_slider: true,
      },
      coming_soon: {
        image_marquee: true,
        text_marquee: true,
        video_marquee: true,
        animated_heading: true,
        animated_word_roller: true,
        news_ticker: true,
        button_marquee: true,
        card_marquee: true,
        media_marquee: true,
        post_marquee: true,
        product_marquee: true,
      },
    },
    // bricks: {
    // 	name: 'Bricks',
    // 	description: 'Visual website builder',
    // 	widgets: {},
    // 	elements: {
    // 		marquee_element: true,
    // 		news_ticker_element: true,
    // 		infinite_slider_element: true
    // 	},
    // 	shortcodes: {}
    // },
    // shortcode: {
    // 	name: 'Shortcodes',
    // 	description: 'Universal shortcode support',
    // 	widgets: {},
    // 	elements: {},
    // 	shortcodes: {
    // 		marquee: true,
    // 		news_ticker: true,
    // 		infinite_slider: true
    // 	}
    // }
  };

  return state?.builderConfigs || defaultConfigs;
}

export function isLoading(state) {
  return getLoading(state);
}
